/**
 * Which body of teams the gallery lists — CABAL Selection (public catalog) or
 * the viewer's Owned Collection.
 *
 * Its own leaf module, deliberately import-free: the gallery's pure contract
 * layer (gallery.team-contract.ts) and its node:test suite classify by this
 * value, and gallery.constants.ts — which re-exports it for every rendering
 * host — carries React, framer-motion and the teams context with it.
 */

export enum TeamsGalleryCollection {
  Selection = "selection",
  Owned = "owned",
}
